import React from 'react';
import { ReactMarkdownDisplay } from '../../../../../PageElements/ReactMarkdownDisplay';

export const SearchResultSummary = ({
  summary,
  description,
  highlights,
}: {
  summary: string;
  description: string;
  highlights: { [key: string]: string[] };
}) => {
  return (
    <ReactMarkdownDisplay
      markdown={summaryWithHightlights(summary, description, highlights)}
      dataHooks={{ p: 'summary-p' }}
      textSize="small"
      renderers={{
        code: () => '',
        linkReference: () => ({ children }) => children,
        link: () => ({ children }) => children,
      }}
      allowRerenders={true}
    />
  );
};

export function summaryWithHightlights(
  summary = '',
  description = '',
  highlights: { [key: string]: string[] },
) {
  if (highlights) {
    const {
      summary: highlightedSummary = [],
      description: highlightedDesc = [],
    } = highlights;

    const highlightedSummaryAndDesc = [
      ...highlightedSummary,
      ...highlightedDesc,
    ].join(' ... ');

    return highlightedSummaryAndDesc || getShortSummary(summary, description);
  }
  return getShortSummary(summary, description);
}

export function getShortSummary(summary = '', desc = '') {
  const summaryAndDesc =
    summary && desc ? `${summary} ... ${desc}` : summary || desc;
  return summaryAndDesc.length > 200
    ? `${summaryAndDesc.slice(0, 200)} ...`
    : summaryAndDesc;
}
